import {BaseModel} from "../base";

class ClinicModel extends BaseModel {

    constructor(data) {
        super(data);
        this.setTimes();
        this.setResourcesAndPeople();
        if (!this.settings) {
            this.settings = {};
        }
    }


    /**
     * @description
     * Set resources and people for clinic
     *
     * @returns {object} The returned resources and people
     */
    setResourcesAndPeople() {
        this.resources = _.reduce(this.resource_ids, (h, id) => {
                h[id] = true;
                return h;
            }
            , {});
        this.people = _.reduce(this.person_ids, (h, id) => {
                h[id] = true;
                return h;
            }
            , {});
        this.services = _.reduce(this.service_ids, (h, id) => {
                h[id] = true;
                return h;
            }
            , {});
        this.uncovered = !this.person_ids || (this.person_ids.length === 0);
        if (this.uncovered) {
            return this.className = 'clinic_uncovered';
        } else {
            return this.className = 'clinic_covered';
        }
    }


    /**
     * @description
     * Set time for clinic
     *
     * @returns {object} The returned time
     */
    setTimes() {
        if (this.start_time) {
            this.start_time = moment(this.start_time);
            this.start = this.start_time;
        }
        if (this.end_time) {
            this.end_time = moment(this.end_time);
            this.end = this.end_time;
        }
        return this.title = this.name;
    }
}

export {
    ClinicModel
}